import React from "react";
import { Link } from "react-router-dom";

function OrderItem(props) {
/* 
  function convert(num) {
    //return num;
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
*/
  return (
    <>
      <div className="articolo_ordine">
        <div className="img_articolo_ordine">
          <Link to={props.urlItem}>
            <img
              src={props.urlImg}
              alt={props.item.detail[0].images[0].alt}
              title={props.item.detail[0].nome}
            />
          </Link>
        </div>
        <div>
          <div className="dati_articolo_ordine">
            <Link to={props.urlItem}>
              <h2>{props.item.detail[0].nome}</h2>
            </Link>
            <h3>Codice: {props.item.detail[0].codice}</h3>
          </div>

          <div className="prezzo_ordine">
            <p>
              <span>Prezzo:</span>&euro; {props.convert(props.item.prezzo_unitario)}
            </p>
          </div>

          <div className="qta_ordine">
            <p>
              <span>Quantit&agrave;:</span>
              {
                //parseInt(props.item.quantita)
                props.item.quantita
              }
            </p>
          </div>
          <div className="totale_ordine">
            <p>
              <span>Totale:</span>&euro;&nbsp;
              {props.convert(props.item.prezzo_totale)}
            </p>
          </div>
        </div>
      </div>
      <div className="AW-clear"></div>
    </>
  );
}

export default OrderItem;